import { DayEnum } from '@/common/enums'
import { CourierSchedule } from '@/common/types'

const weekDays = Object.values(DayEnum)

export const buildEnabledDays = (items: CourierSchedule[] = []) => {
    return weekDays.reduce((acc, day) => {
        const entry = items.find((item) => item.day === day)
        acc[day] = Boolean(entry?.startTime || entry?.endTime)
        return acc
    }, {} as Record<DayEnum, boolean>)
}

export const normalizeWorkingHours = (items: CourierSchedule[] = []): CourierSchedule[] => {
    return weekDays.map((day) => {
        const existing = items.find((item) => item.day === day)
        return {
            day,
            startTime: existing?.startTime || '',
            endTime: existing?.endTime || '',
        }
    })
}

export const hasAnyWorkingHours = (items: CourierSchedule[] = []) => {
    return items.some((item) => item.startTime || item.endTime)
}
